import {
  AfterViewChecked,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  RendererStyleFlags2,
  ViewChild,
} from "@angular/core";
import { CoreConfigService } from "@core/services/config.service";
import { AreaPoligono } from "./AreaPoligono";
import { LandingService } from "../landing.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SwiperComponent, SwiperConfigInterface, SwiperDirective } from "ngx-swiper-wrapper";
import { ProyectoService } from "./proyecto.service";
import { environment } from "environments/environment";
import { NgxGalleryAnimation, NgxGalleryImage, NgxGalleryOptions } from "@kolkov/ngx-gallery";
declare var google: any;

@Component({
  selector: "app-proyecto",
  templateUrl: "./proyecto.component.html",
  styleUrls: ["./proyecto.component.scss"],
})
export class ProyectoComponent implements OnInit, AfterViewChecked {
  @ViewChild("miImagen", { static: false }) imagenRef!: ElementRef;
  @ViewChild("miCanvas", { static: false }) canvasRef!: ElementRef;
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;
  @Input() edificio: any;
  private ctx!: CanvasRenderingContext2D;
  poligonos: any[] = [];

  sortDirection = "asc";
  page = 1;
  pageSize = 10;
  sizeTable = 0;

  public configSwal: SwiperConfigInterface = {
    slidesPerView: "auto",
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: true,
    spaceBetween: 38,
    autoplay: true,
  };

  public galleryOptions: NgxGalleryOptions[] = [
    {
      height: "650px",
      width: "100%",
      thumbnails: false,
      imageAnimation: NgxGalleryAnimation.Slide,
      imageArrowsAutoHide: true,
      imageAutoPlay: true,
      imageAutoPlayInterval: 5000,
      imageAutoPlayPauseOnHover: true,
      previewZoom: true,
      previewBullets: true,
      previewKeyboardNavigation: true,
      previewCloseOnEsc: true,
      previewSwipe: true,
    },
    // max-width 1050
    {
      breakpoint: 1050,
      width: "100%",
      height: "400px",
      imagePercent: 80,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
    },
    // max-width 800
    {
      breakpoint: 950,
      width: "100%",
      height: "300px",
      imagePercent: 80,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
    },
    // max-width 850
    {
      breakpoint: 850,
      width: "100%",
      height: "250px",
      imagePercent: 80,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
    },
    {
      breakpoint: 400,
      width: "100%",
      height: "180px",
      imagePercent: 80,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
    },
  ];

  public gallerySlider: NgxGalleryImage[] = [];

  map: any;
  marker: any;
  inicio: any = { lat: 0, lng: 0 };

  layoutsPorGrupo: any;

  project: any;

  layouts: any = [];
  layoutSelected: any;
  layoutsReverse: any;
  layout: any;

  floors: any;
  floor: any = null;

  puntos: any = [];
  puntos_ajustados: any = [];

  estates: any[] = [];
  temp_estates: any[] = [];
  amenities: any[] = [];

  random_estates: any = [];

  building: any = [];

  config: any;

  public galleryImages: any = [];

  buttons: any = [];
  public toggleSlidesPerView(): void {
    if (this.configSwal.slidesPerView !== 1) {
      this.configSwal.slidesPerView = 1;
    } else {
      this.configSwal.slidesPerView = 2;
    }
  }

  constructor(
    private _coreConfigService: CoreConfigService,
    private landing_service: LandingService,
    private project_service: ProyectoService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
    var host = window.location.host;
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    this.landing_service.getConfig(data).then(
      (data: any) => {
        this.config = data;

        const mapClass = document.getElementById("mapClass");
        const shareClass = document.getElementById("shareClass");

        if (mapClass != null) {
          if (this.config?.theme === 1) {
            mapClass.classList.add("col-md-6");
          }
        }

        if (shareClass != null) {
          if (this.config?.theme === 1) {
            shareClass.classList.add("col-md-6");
          }
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: any) {
    // PUNTOS
    this.onResize();

    // AREAS
    this.createCanvas().then(() => {
      if (this.poligonos.length > 0) {
        this.borrarCanvas();
        this._recalcularCoordenadasPoligonos();
        this._dibujarAreas();
      }
    });
  }

  async onResize() {
    // for(let punto of this.puntos) punto.review = false;
    await this.ajustarCoordenadas2();
  }

  borrarCanvas(): void {
    this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
  }

  private _recalcularCoordenadasPoligonos() {
    const canvas = this.canvasRef.nativeElement;
    const escalaX = canvas.width / canvas.clientWidth;
    const escalaY = canvas.height / canvas.clientHeight;

    for (const poligono of this.poligonos) {
      for (const vertice of poligono.vertices) {
        vertice.x *= escalaX;
        vertice.y *= escalaY;
      }
      // Luego, actualiza el Path2D con las nuevas coordenadas
      poligono.actualizarPath(poligono.vertices);
    }
  }

  async ngOnInit() {
    await this.getProject();
    await this.getAmenities();
    await this.getBuilding();
    await this.getLayouts();
    await this.initMap();
    this.changeLay(this.layouts[0].id);
  }

  ngAfterViewChecked() {
    // const buscador = document.querySelector("app-header-buscador");
    // if (buscador) {
    //   const height = buscador.clientHeight;
    //   const gallery = document.getElementById("gallery-slide");
    //   if (gallery.style) gallery.style.minHeight = `calc(100vh - ${height}px)`;
    // }
  }

  scrollToElement(element: string): void {
    const elementId = document.getElementById(element);
    if (elementId) {
      elementId.scrollIntoView({ behavior: "smooth" });
    }
  }

  async getProject() {
    return new Promise((resolve, reject) => {
      try {
        const id_project = this.route.snapshot.paramMap.get("id_project");
        const id_real_estate = this.route.snapshot.paramMap.get("id_real_estate");
        this.project_service.getProyecto(Number(id_project)).then(
          (res: any) => {
            this.project = res.data;
            this.estates = this.temp_estates = res.data.estates;
            this.sizeTable = this.estates.length;
            this.getPageData();
            for (let i = 0; i < (res.data.estates.length > 3 ? 3 : res.data.estates.length); i++) {
              let random = Math.floor(Math.random() * res.data.estates.length);
              if (this.random_estates.indexOf(res.data.estates[random]) == -1) {
                this.random_estates.push(res.data.estates[random]);
              } else {
                i--;
              }
            }
            this.project.Slider?.forEach((img: any) => {
              this.gallerySlider.push({
                small: img.url,
                medium: img.url,
                big: img.url,
              });
            });
            resolve(true);
          },
          (error: any) => {
            console.log("Error getProject()", error);
            reject(false);
          }
        );
      } catch (error: any) {
        console.log("Error getProject()", error);
      }
    });
  }

  async initMap() {
    return new Promise((resolve, reject) => {
      const coord = { lat: Number(this.project.latitude), lng: Number(this.project.longitude) };
      const icon = {
        url: "assets/icon/home.png",
        scaledSize: new google.maps.Size(50, 50),
      };
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: coord,
        zoom: 15,
        panControl: false,
        streetViewControl: false,
        scaleControl: false,
        overviewMapControl: false,
        mapTypeControl: false,
      });

      this.marker = new google.maps.Marker({
        position: {
          lat: Number(coord.lat),
          lng: Number(coord.lng),
        },
        map: this.map,
        icon,
      });
      resolve(true);
    });
  }

  async getAmenities() {
    return new Promise((resolve, reject) => {
      try {
        this.project_service.getAmenities(this.project.id, this.project.real_estate_id).then(
          (res: any) => {
            this.amenities = res.data;
            resolve(true);
          },
          (error: any) => {
            console.log("Error getAmenities()", error);
            reject(false);
          }
        );
      } catch (error: any) {
        console.log("Error getAmenities()", error);
      }
    });
  }

  async getBuilding() {
    return new Promise((resolve, reject) => {
      try {
        this.project_service.getBuilding(this.project.id, this.project.real_estate_id).then(
          (res: any) => {
            this.building = res.data;
            if (this.building.length > 0) {
              this.building = this.building[this.building.length - 1];
              this.project_service.disparadorDeEdificio.emit(this.building);
            }
            resolve(true);
          },
          (error: any) => {
            console.log("Error getBuilding()", error);
            reject(false);
          }
        );
      } catch (error: any) {
        console.log("Error getBuilding()", error);
      }
    });
  }

  async getLayouts() {
    return new Promise((resolve, reject) => {
      try {
        this.project_service.getLayouts(this.project.id, this.project.real_estate_id).then(
          (res: any) => {
            this.layouts = res.data;
            // this.layoutsReverse = this.layouts.reverse();
            resolve(true);
          },
          (error: any) => {
            console.log("Error getLayouts()", error);
            reject(false);
          }
        );
      } catch (error: any) {
        console.log("Error getLayouts()", error);
      }
    });
  }

  chunkArray(arr: [], chunkSize: number) {
    const groups = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
  }

  changeLay(id: any) {
    this.layoutSelected = id;
    this.project_service.reset.emit();
    this.project_service.disparadorDeLayout.emit(this.layouts.find((x: any) => x.id == id));
  }

  async selectLayout(layout: any) {
    this.layout = layout;
    await this.getLayoutPoints();
    await this.ajustarCoordenadas2();
  }

  async getLayoutPoints() {
    try {
      this.onWindowResize(null);
    } catch (error: any) {
      console.log("Error getLayoutPoints()", error);
    }
  }

  ajustarCoordenadas2() {
    this.puntos_ajustados = this.puntos.map((punto: any) => {
      const xx = punto.x / this.layout.width;
      const x = xx * 100;
      const yy = punto.y / this.layout.height;
      const y = yy * 100;

      return { ...punto, x, y };
    });
  }

  scrollToSection() {
    const element = document.getElementById("CONTACTO");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  mostrarInformacion(punto: any) {
    punto.mostrarPopup = true;
  }
  ocultarInformacion() {
    for (let punto of this.puntos_ajustados) {
      punto.mostrarPopup = false;
    }
  }

  async createCanvas() {
    const imagen = this.imagenRef.nativeElement;
    const canvas = this.canvasRef.nativeElement;

    this.ctx = canvas.getContext("2d");
    // Asigna el mismo tamaño que la imagen al canvas
    canvas.width = imagen.clientWidth; //this.layout.width; //imagen.width;
    canvas.height = imagen.clientHeight; //this.layout.height; //imagen.height;
    // };

    await this.indexUbicationsEstateLayout();
  }

  async indexUbicationsEstateLayout() {
    this.poligonos = [];
    let poligons = [];
    // await this._ubication_estates_service.indexUbicationsEstateLayout(
    //   this.layout.id
    // );

    poligons = Object.values(poligons);
    try {
      for (let pol1 of poligons) {
        let colorFill = "rgba(0, 255, 0, 0.5)";
        pol1 = pol1;
        let vertices = [];
        for (let pol2 of pol1) {
          if (pol2.estate.available != 1) {
            colorFill = "rgba(255, 0, 0, 0.5)";
          }
          vertices.push({ x: pol2.x, y: pol2.y });
        }
        if (vertices.length > 2) {
          const poligono = new AreaPoligono(
            vertices,
            pol1[0].estate_id,
            pol1[0].estate,
            "blue",
            colorFill,
            this.ctx,
            this.imagenRef
          );
          this.poligonos.push(poligono);
        }
      }
      this._dibujarAreas();
    } catch (error: any) {
      console.log("Error indexUbicationsEstateLayout()", error);
    }
  }

  private async _dibujarAreas() {
    for (let item1 of this.poligonos) {
      item1.dibujar(this.ctx);
    }
  }

  async checkAreaUpdate(event: MouseEvent) {
    let poligono_seleccionado = 0;
    // await this.borrarCanvas();
    for (let item1 of this.poligonos) {
      const rect = this.canvasRef.nativeElement.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const value = item1.verificarClick(x, y);
      if (value) {
        // Navigate to property page
        window.open("/T1/projects/single-project/property/" + item1.estate_id, "_blank");

        poligono_seleccionado++;
      } else {
        // item1.dibujar(this.ctx);
      }
    }
    if (poligono_seleccionado == 0) {
      // this._swal_service.swalInfo('No existe un area seleccionada para actualizar');
    }
  }

  openFloor(piso: any) {
    this.floor = piso;
    this.selectLayout(this.floor);
  }

  async getButtons() {
    for (let i: number = 0; i < 5; i++) {
      this.buttons.push({
        id: i,
        text: "Button " + i,
        color: "primary",
      });
    }
  }

  goToRealEstateDomain() {
    let ruta;
    var host = window.location.host;
    if (host.includes("localhost") || host.includes("qa")) {
      // this.urlShareCopy = host + '/detalles/' + this.property.id;
      ruta = host + "/" + this.project.real_estate?.domain + ".inmoapp.mx";
    } else {
      ruta = "https://" + this.project.real_estate?.domain + ".inmoapp.mx";
    }

    setTimeout(() => {
      const ruta = "https://" + this.project.real_estate?.domain + ".inmoapp.mx"; //'https://inmoapp.mx/';
      window.open(ruta, "_blank");
    }, 500);
  }

  goToDetalles(property_id: any) {
    window.open("/detalles/" + property_id, "_blank");
  }

  getPageData() {
    this.estates = this.temp_estates.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  sortData(property: string) {
    const isAsc = this.sortDirection === "asc";
    this.temp_estates.sort((a, b) => {
      const valA = a[property];
      const valB = b[property];

      if (valA == null || valB == null) {
        return 0;
      }

      if (isAsc) {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });

    this.sortDirection = isAsc ? "desc" : "asc";

    this.getPageData();
  }
}
